<template>
<div>
    <button class="link" type="button" @click="generate()"><slot></slot></button>
</div>
</template>

<script>
export default {
    methods: {

        generate() {

            // Set characters
            let lowercaseCharacterSet = 'abcdefghijklmnopqrstuvwxyz'
            let uppercaseCharacterSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
            let numberCharacterSet = '0123456789'
            let symbolCharacterSet = '![]{}()%&*$#^<>~@|-_'
            let allCharacterSet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789![]{}()%&*$#^<>~@|-_';

            // Set password Length
            let passwordLength = 12

            // Add min. lower, upper, number and symbol (length=4)
            let password = '';
            password += lowercaseCharacterSet.charAt(Math.floor(Math.random() * lowercaseCharacterSet.length));
            password += uppercaseCharacterSet.charAt(Math.floor(Math.random() * uppercaseCharacterSet.length));
            password += numberCharacterSet.charAt(Math.floor(Math.random() * numberCharacterSet.length));
            password += symbolCharacterSet.charAt(Math.floor(Math.random() * symbolCharacterSet.length));

            // Complete the rest with random characters
            for (let i = 4; i < passwordLength; i++) {
                password += allCharacterSet.charAt(Math.floor(Math.random() * allCharacterSet.length));
            }

            // Random ordering
            let passwordShuffledArray = password.split('').sort(function(a, b) {
                return Math.random() > .5 ? -1 : 1
            });
            let passwordShuffled = passwordShuffledArray.join('')

            this.$emit('generated-password', passwordShuffled)

        }
    }
}
</script>
